import get from 'lodash/get';
import { ROUTES } from './routes';
import { CARD_TYPE } from './cardType';

export const STEPS = {
  SELECT_DATE: 'selectDate',
  PERSONAL_DETAILS: 'personalDetails',
  MEDICARE: 'medicare',
  CONFIRMATION: 'confirmation',
};

const { SELECT_DATE, PERSONAL_DETAILS, MEDICARE, CONFIRMATION } = STEPS;

export const STEP_ORDERS = [
  SELECT_DATE,
  PERSONAL_DETAILS,
  MEDICARE,
  CONFIRMATION,
];

export const STEP_MAPPING = {
  [SELECT_DATE]: {
    stepNumber: 1,
    stepTitle: 'Appointment',
    title: 'Your appointment is with',
    subtitle: 'Check the fee, then choose a date and time that suits you.',
    route: ROUTES.SELECT_DATE,
  },
  [PERSONAL_DETAILS]: {
    stepNumber: 2,
    stepTitle: 'Personal details',
    title: 'Personal details',
    subtitle: 'We use these to identify you and to lodge your Medicare claim.',
    route: ROUTES.PERSONAL_DETAILS,
  },
  [MEDICARE]: {
    stepNumber: 3,
    stepTitle: 'Medicare & health',
    title: 'Medicare & health information',
    subtitle: 'Adding your Medicare card lets us claim your rebate for you.',
    route: ROUTES.MEDICARE,
  },
  [CONFIRMATION]: {
    stepNumber: 4,
    stepTitle: 'Confirmation',
    title: 'Confirmation',
    subtitle: 'Please review before you confirm.',
    route: ROUTES.CONFIRMATION,
  },
  [undefined]: {
    stepNumber: 1,
    stepTitle: 'Appointment',
    title: 'Your appointment is with',
  },
};

export const BOOKING_STEPS = STEP_ORDERS.map((step) => ({
  key: step,
  title: STEP_MAPPING[step].stepTitle,
}));

export const BOOKING_COUNTER_PREFIX = {
  NEW: 'New booking',
  REVIEW: 'Review booking',
};

export const TOTAL_STEPS = STEP_ORDERS.length;

export const NEXT = 'next';
export const BACK = 'back';

const isMedicareCardSelected = (bookingData) =>
  get(bookingData, 'medicare.cardType', CARD_TYPE.MEDICARE) ===
  CARD_TYPE.MEDICARE;

const isDvaCardSelected = (bookingData) =>
  get(bookingData, 'medicare.cardType') === CARD_TYPE.DVA;

export const BOOKING_ERRORS = [
  {
    path: 'appointmentTime.timezone',
    error: 'The timezone of booking time is required.',
  },
  { path: 'appointmentTime.start', error: 'Booking time is required' },
  { path: 'personalDetails.firstName', error: 'Please input your first name' },
  { path: 'personalDetails.lastName', error: 'Please input your last name' },
  {
    path: 'personalDetails.dateOfBirth',
    error: 'Please input your date of birth',
  },
  { path: 'personalDetails.mobile', error: 'Please input your mobile number' },
  { path: 'personalDetails.email', error: 'Please input your email' },
  {
    path: 'medicare.medicareCardNumber',
    error: 'Please input your medicare card number',
    when: isMedicareCardSelected,
  },
  {
    path: 'medicare.medicareCardIRN',
    error: 'Please input your medicare card IRN',
    when: isMedicareCardSelected,
  },
  {
    path: 'medicare.expiry',
    error: 'Please input your medicare expiry time',
    when: isMedicareCardSelected,
  },
  {
    path: 'medicare.dvaNumber',
    error: 'Please input your DVA card number',
    when: isDvaCardSelected,
  },
  {
    path: 'medicare.dvaCardType',
    error: 'Please select your DVA card type',
    when: isDvaCardSelected,
  },
];
